export const CHAT_URL = "https://chat.yuukke.betalearnings.com/";
export const API_URL = 'http://connect.yuukke.betalearnings.com/admin/'
export const SOCKET_URL = "https://chat.yuukke.betalearnings.com/"
export const JITSI_URL = "https://meeting.jitsi.betalearnings.com/"

